/**
 * JSON.stringify with sorted object keys so equivalent objects produce the same string.
 * Used for API dedupe keys (filters, payloads) regardless of insertion order.
 */
export function stableStringify(value) {
  if (value === undefined) return 'undefined';
  if (value === null) return 'null';
  const t = typeof value;
  if (t === 'number' || t === 'boolean' || t === 'string') return JSON.stringify(value);
  if (t === 'bigint') return JSON.stringify(String(value));
  if (Array.isArray(value)) {
    return `[${value.map((v) => stableStringify(v)).join(',')}]`;
  }
  if (t === 'object') {
    if (typeof value.format === 'function' && typeof value.isValid === 'function') {
      try {
        return JSON.stringify(value.isValid?.() ? value.format('YYYY-MM-DD') : String(value));
      } catch {
        return JSON.stringify(String(value));
      }
    }
    const keys = Object.keys(value).sort();
    return `{${keys.map((k) => JSON.stringify(k) + ':' + stableStringify(value[k])).join(',')}}`;
  }
  return JSON.stringify(String(value));
}
